import actionTypes from "./actionTypes";
export default {
    setPanelWidth: (width) => ({
        type: actionTypes.SET_PANEL_WIDTH,
        width
    })
};
